import { AnyAction } from 'redux';
import { Employee } from '@synergy/models';

import {
    CUSTOMER_EMPLOYEES_ADD,
    CUSTOMER_EMPLOYEES_CHANGE_POSITION,
    CUSTOMER_EMPLOYEES_CHANGE_TAGS,
    CUSTOMER_EMPLOYEES_RECEIVED,
    CUSTOMER_EMPLOYEES_REMOVE,
    CUSTOMER_EMPLOYEES_SET_AS_BONUS_CONTACT,
    CUSTOMER_EMPLOYEES_SET_AS_MAIN_CONTACT,
} from './customer-employee-actions';

export interface CustomerEmployeeReducerState {
    employees: Employee[] | null;
    bonusContactCount: number;
}

export const initialCustomerEmployeeReducerState: CustomerEmployeeReducerState = {
    employees: null,
    bonusContactCount: 0,
};

export const customerEmployeeReducer = (
    state: CustomerEmployeeReducerState = initialCustomerEmployeeReducerState,
    action: AnyAction
): CustomerEmployeeReducerState => {
    switch (action.type) {
        case CUSTOMER_EMPLOYEES_RECEIVED: {
            return {
                ...state,
                employees: action['employees'],
                bonusContactCount: action['bonusContactCount'],
            };
        }

        case CUSTOMER_EMPLOYEES_ADD: {
            return {
                ...state,
                employees: [...(state.employees ?? []), action['employee']],
            };
        }

        case CUSTOMER_EMPLOYEES_REMOVE: {
            const nextEmployees = state.employees?.filter(employee => employee.id !== action['employeeId']) ?? [];

            nextEmployees.forEach(employee => {
                if (action['reassignMainContactId']) {
                    employee.isMainContact = employee.id === action['reassignMainContactId'];
                }
            });

            return {
                ...state,
                employees: nextEmployees,
            };
        }

        case CUSTOMER_EMPLOYEES_SET_AS_MAIN_CONTACT: {
            return {
                ...state,
                employees: (state.employees ?? []).map(employee => ({
                    ...employee,
                    isMainContact: employee.id === action['employeeId'],
                })),
            };
        }

        case CUSTOMER_EMPLOYEES_SET_AS_BONUS_CONTACT: {
            return {
                ...state,
                employees: (state.employees ?? []).map(employee => ({
                    ...employee,
                    isBonusContact:
                        employee.id === action['employeeId'] ? action['isBonusContact'] : employee.isBonusContact,
                })),
                bonusContactCount: action['isBonusContact'] ? state.bonusContactCount + 1 : state.bonusContactCount - 1,
            };
        }

        case CUSTOMER_EMPLOYEES_CHANGE_POSITION: {
            const nextEmployees = [...(state.employees ?? [])];
            const index = nextEmployees.findIndex(employee => employee.id === action['employeeId']);
            if (index < 0) {
                return state;
            }

            nextEmployees[index].position = action['position'];
            return {
                ...state,
                employees: nextEmployees,
            };
        }

        case CUSTOMER_EMPLOYEES_CHANGE_TAGS: {
            const nextEmployees = [...(state.employees ?? [])];
            const index = nextEmployees.findIndex(employee => employee.id === action['employeeId']);
            if (index < 0) {
                return state;
            }

            nextEmployees[index].tags = action['tags'];
            return {
                ...state,
                employees: nextEmployees,
            };
        }

        default: {
            return state;
        }
    }
};
